import { Layout } from "antd";

const { Content } = Layout;
const LayoutQuiz: React.FC<{ children?: React.ReactNode }> = (props) => {
  const { children } = props;

  return (
    <Layout className="layout-quiz">
      <Content> {children}</Content>
    </Layout>
  );
};

export default LayoutQuiz;
